import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import * as BasicScroll from 'basicscroll';
import barba from '@barba/core';

const initTeamGrid = () => {
    setTimeout(() => {
        let teamGrids = document.querySelectorAll(
            '.team-grid:not(.is-initialized)'
        );

        teamGrids.forEach((teamGrid) => {
            teamGrid.classList.add('is-initialized');
            const masonryContainer = teamGrid.querySelector(
                '.team-grid__masonry'
            );

            const masonry = new Masonry(masonryContainer, {
                gutter: 32,
                itemSelector: '.team-grid__masonry__item', // Stelle sicher, dass du ein gültiges itemSelector angibst
            });

            imagesLoaded(masonryContainer, () => {
                masonry.layout();
            });

            const basicScroll = BasicScroll.create({
                elem: masonryContainer,
                from: 'top-bottom',
                to: 'bottom-top',
                direct: teamGrid,
                props: {
                    '--team-grid-scroll': {
                        from: '0',
                        to: '100',
                    },
                },
            });
            basicScroll.start();
            barba.hooks.after(() => {
                basicScroll.calculate();
            });

            const updateColumns = () => {
                let columns = {};
                masonry.items.forEach((item) => {
                    if (!columns[item.position.x]) {
                        columns[item.position.x] = [];
                    }
                    columns[item.position.x].push(item);
                });

                Object.keys(columns).forEach((column, index) => {
                    columns[column].forEach((item) => {
                        item.element.setAttribute('data-col', index + 1);
                    });
                });
            };

            masonry.on('layoutComplete', () => {
                updateColumns();
            });
            updateColumns();
        });
    }, 600);
};

barba.hooks.beforeEnter(initTeamGrid);
document.addEventListener('DOMContentLoaded', initTeamGrid);
